import { Id, toast } from "react-toastify";
export const updateToast = (toastId: Id, message: string, type: "success" | "error", autoClose = 5000) => {
  toast.update(toastId, {
    render: message,
    type: type,
    isLoading: false,
    autoClose: autoClose,
    closeButton: true,
  });
};